import MaterialReactTable from "material-react-table";
import { useState } from "react";
import {
  EmptyPaper,
  LoadingError,
  LoadingPaper,
} from "../../LoadingComponents";
import { Box, Dialog, IconButton, MenuItem } from "@mui/material";
import { Visibility as ViewIcon } from "@mui/icons-material";
import { pressureColumns, commonColumns } from "./TabsColumns";
import { useGetPatientReports } from "../useReportQueries";
import PressureReport from "../ViewReport/PressureReport";

function PressureTab({ patient_id }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 20 });
  const dataQuery = useGetPatientReports(patient_id, 3, {
    page: pagination.pageIndex + 1,
    per_page: pagination.pageSize,
  });

  // === ViewReport modal handling ===
  const [openViewReport, setOpenViewReport] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  const handleOpenViewReport = (report_id) => {
    setSelectedReport(report_id);
    setOpenViewReport(true);
  };
  const handleCloseViewReport = () => {
    setOpenViewReport(false);
  };

  let tableColumns = [...commonColumns, ...pressureColumns];

  return (
    <main
      style={{
        width: "100%",
      }}
    >
      <Dialog open={openViewReport} fullScreen>
        <PressureReport
          patient_id={patient_id}
          closeModal={handleCloseViewReport}
          report_id={selectedReport}
        />
      </Dialog>

      {dataQuery.isLoading ? (
        <LoadingPaper />
      ) : dataQuery.isError ? (
        <LoadingError error={dataQuery.error} />
      ) : (
        dataQuery.isSuccess &&
        (dataQuery.data.reports.length === 0 ? (
          <EmptyPaper
            message={"Nessun report Pressione associato al paziente"}
          />
        ) : (
          <MaterialReactTable
            columns={tableColumns}
            data={dataQuery.data?.reports || []}
            initialState={{
              density: "compact",
              showColumnFilters: false,
            }}
            enablePagination={true}
            manualPagination
            rowCount={dataQuery.data?.total ?? 0}
            onPaginationChange={setPagination}
            state={{ pagination }}
            enableBottomToolbar={true}
            enableTopToolbar={false}
            enableSorting={false}
            muiTablePaperProps={{
              elevation: 0,
            }}
            muiTableContainerProps={{
              sx: {
                overflowX: "hidden",
              },
            }}
            enableColumnResizing
            enableColumnActions={false}
            enableRowSelection={false}
            displayColumnDefOptions={{
              "mrt-row-actions": { header: "Report" },
            }}
            enableRowActions={true}
            positionActionsColumn="last"
            renderRowActions={({ row, table }) => [
              <IconButton
                key="view"
                disabled={
                  row.original.data.Pmax === undefined ||
                  row.original.data.Pmax === null
                }
                onClick={() => {
                  handleOpenViewReport(row.original.id);
                }}
              >
                <ViewIcon color="primary" />
              </IconButton>,
            ]}
          />
        ))
      )}
    </main>
  );
}

export default PressureTab;
